import { render, staticRenderFns } from "./CourseTranscriptForm.vue?vue&type=template&id=e312df64&scoped=true&"
import script from "./CourseTranscriptForm.vue?vue&type=script&lang=ts&"
export * from "./CourseTranscriptForm.vue?vue&type=script&lang=ts&"
import style0 from "./CourseTranscriptForm.vue?vue&type=style&index=0&id=e312df64&prod&lang=scss&scoped=true&"
import style1 from "./CourseTranscriptForm.vue?vue&type=style&index=1&id=e312df64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e312df64",
  null
  
)

export default component.exports